<template>
  <div class="pago-principal">
    <titulo-seccion
      :titulo="
        tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7
          ? 'PAGO DE CUOTA DE INSCRIPCIÓN'
          : 'REGISTRATION FEE PAYMENT'
      "
    ></titulo-seccion>
    <!--Modal Observacion -->
    <ModalObservacion :Observacion="ObservacionComprobante"></ModalObservacion>
    <!--Elección de método de pago-->
    <div
      class="container contenedor-metodo-pago mt-4"
      v-if="mostrarTextoPagoNoProcesado"
    >
      <div class="contenedor__no-procesado">
        <i class="fas fa-exclamation-circle"></i>
        <label class="texto__no-procesado" style="text-align:center;">
          {{
            tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7
              ? "No logramos procesar tu último pago, por favor intenta realizar tu pago nuevamente o carga un comprobante si ya realizaste un pago en ventanilla."
              : "We were unable to process your last payment, please try to make your payment again or upload a receipt if you have already made a cash pickup payment."
          }}
        </label>
      </div>
    </div>
    <div
      class="container contenedor-metodo-pago mt-3"
      v-if="mostrarmediosPagoEfectivo"
    >
      <div class="row">
        <p class="titulo-seccionPago"
          >{{
            tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7
              ? "Métodos de Pago"
              : "Payment Methods"
          }}
        </p>
        <p class="parrafo-instrucciones w-80 mt-2">
          {{
            tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7
              ? "Si ya realizaste tu pago, Por favor elige el medio porque cuál lo hiciste:"
              : "If you have already made your payment, please choose the method of payment:"
          }}
        </p>
        <div class="col-lg-12 campo-solicitud" style="padding-top: 0">
          <DropDown
            :requerido="true"
            :invalidFeedback="
              tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7
                ? 'Debes seleccionar un medio de pago'
                : 'You must select a payment method'
            "
            :placeholder="
              tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7
                ? 'Selecciona un medio de pago *'
                : 'Select a payment method *'
            "
            :arreglo="catalogos.mediosPagoEfectivo"
            llave="value"
            valor="value"
            texto="text"
            v-model="DatosPago.tipoMedioPago"
          ></DropDown>
        </div>
      </div>
    </div>
    <!--Carga de comprobante de pago-->
    <div
      :class="
        ProspectoTieneComprobantes
          ? 'container contenedor-metodo-pago mt-4'
          : 'container contenedor-metodo-pago'
      "
      v-if="muestraCargaComprobante"
    >
      <div class="row row-cols-lg-12">
        <label class="parrafo-instrucciones" style="font-weight: 500">
          {{
            tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7
              ? "Carga o actualiza aquí tu comprobante de pago:"
              : "Upload or update here your payment receipt:"
          }}
        </label>
      </div>
      <div
        class="row row-cols-lg-12 mt-0"
        style="padding: 10px"
        v-for="(comprobante, index) in comprobantesCargados"
        :key="index"
      >
        <input
          :disabled="comprobante.archivoId != null"
          ref="inputComprobantePago"
          class="d-none"
          type="file"
          @change="almacenarArchivoComprobante($event, index)"
        />
        <div class="col-lg-10">
          <InputDocumentos
            :disabled="comprobante.archivoId != null"
            @click.native="activaInputComprobantePago(index)"
            ajusteMarginBoton="margin-top: -0.2px !important"
            :Documento="0"
            :NombreArchivo="comprobante.nombreOriginal"
            :esExtranjero="tipoPersona == 2 ? true : false"
          ></InputDocumentos>
        </div>
        <div class="col-lg-2 contenedor-iconos-integracion">
          <i
            v-if="comprobante.archivoId != null"
            class="fa fa-download iconoArchivo-png"
            v-on:click="descargarArchivo(comprobante.archivoId)"
          ></i>
          <i
            v-if="
              comprobante.archivoId != null && comprobantesCargados.length >= 1
            "
            class="fa fa-trash iconoBorrar-png"
            v-on:click="eliminarArchivo(comprobante.archivoId)"
          ></i>
          <i
            class="fas fa-exclamation-triangle iconos-archivo icono-observacion"
            v-if="comprobante.esAprobado == false"
            data-bs-toggle="modal"
            data-bs-target="#modalObservacionB"
            @click.prevent="VerObservacionComprobante(comprobante.archivoId, 0)"
          ></i>
        </div>
      </div>
      <div class="row row-cols-lg-12">
        <div class="col-lg-12 subir-otro-comprobante">
          <strong
            v-if="
              comprobantesCargados[comprobantesCargados.length - 1].archivoId !=
                null && comprobantesCargados.length <= 2
            "
            class="w-auto etiqueta-nuevo-documento"
            @click.prevent="MostrarInputsNuevoComprobante()"
          >
            {{
              tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7
                ? "Subir otro comprobante +"
                : "Upload another voucher +"
            }}
          </strong>
        </div>
        <div
          class="col-lg-12 enviar-comprobante"
          v-if="
            comprobantesCargados[comprobantesCargados.length - 1].archivoId !=
              null
          "
        >
          <button
            v-if="enviandoComprobante"
            disabled
            class="
              btn
              boton-primario boton-llenar-solicitud
              contenedor-boton-finaliza-pago__boton
            "
          >
            <v-progress-circular
              indeterminate
              size="30"
              color="primary"
            ></v-progress-circular>
          </button>
          <button
            v-else
            class="
              btn
              boton-primario boton-llenar-solicitud
              contenedor-boton-finaliza-pago__boton
            "
            @click="EnviarComprobantePago()"
          >
            {{
              tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7
                ? "Enviar comprobante"
                : "Send receipt"
            }}
          </button>
        </div>
      </div>
    </div>
    <!--Elección de tipo de pago en línea-->
    <div
      class="container contenedor-metodo-pago mt-4"
      v-if="muestramediosPagoLinea"
    >
      <div class="row">
        <div class="col-lg-6">
          <p class="titulo-seccionPago"
            >{{
              tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7
                ? "Métodos de pago en línea"
                : "Online payment methods"
            }}
          </p>
          
          <div class="row">
            <!-- tipo tarjeta -->
            <div class="col-lg-5 campo-solicitud" style="padding-top: 0" >
              <p class="parrafo-instrucciones mt-2">
                {{
                  tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7
                    ? "Tipo de tarjeta:"
                    : "Card type:"
                }}
              </p>
              <DropDown
                :requerido="true"
                :invalidFeedback="
                  tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7
                    ? 'Seleccionar el tipo'
                    : 'Select a type'
                "
                :placeholder="
                  tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7
                    ? 'Seleccionar... *'
                    : 'Select... *'
                "
                :arreglo="catalogos.tipoTarjetaCD"
                llave="value"
                valor="value"
                texto="text"
                :disabled="mostrarMensajePago === 'Aprobado'"
                v-model="DatosPago.tipoTarjetaCD"
              ></DropDown>
            </div>

            <!-- Tipo de pago -->
            <div class="col-lg-7 campo-solicitud" style="padding-top: 0" >
              <p class="parrafo-instrucciones mt-2">
                {{
                  tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7
                    ? "Difiere tus pagos en:"
                    : "Deferred payment options:"
                }}
              </p>
              <DropDown
                :disabled="DatosPago.tipoTarjetaCD == null || mostrarMensajePago === 'Aprobado'"
                :requerido="true"
                :invalidFeedback="
                  tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7
                    ? 'Debes seleccionar un tipo de pago'
                    : 'You must select a payment type'
                "
                :placeholder="
                  tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7
                    ? 'Seleccionar... *'
                    : 'Select... *'
                "
                :arreglo="catalogos.mediosPagoLinea"
                llave="value"
                valor="value"
                texto="text"
                v-model="DatosPago.tipoPago"
              ></DropDown>
            </div>
            
            <div class="col-lg-12 campo-solicitud" v-if="DatosPago.tipoPago != null">
                <div class="row px-1 resumenPagoContent">
                  <div class="col-9 p-0">
                    <p class="titulo-seccionPago mt-2">
                      {{
                        tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7
                          ? "Resumen de pago"
                          : "Payment summary"
                      }}
                    </p>
                  </div>
                  <div class="col-6 p-0">
                    <p class="m-0 resumenPago">Subtotal:</p>
                  </div>
                  <div class="col-3 p-0">
                    <p class="m-0 resumenPago-moneda">{{currency( this.montoSinDescuento )}}</p>
                  </div>
                  <div class="col-6 p-0">
                  <p class="m-0 resumenPago">{{
                        tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7
                          ? "Descuento"
                          : "Discount"
                      }} ( {{this.montosPago.descuentoCuotaInscripcion * 100}} %): </p>
                  </div>
                  <div class="col-3 p-0">
                    <p class="m-0 resumenPago-moneda">- {{currency(this.montoSinDescuento * this.montosPago.descuentoCuotaInscripcion)}}</p>
                  </div>
                  <div class="col-6 p-0">
                  <p class="m-0 resumenPago">{{
                        tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7
                          ? "IVA:"
                          : "Taxes/VAT:"
                      }}
                  </p>
                  </div>
                  <div class="col-3 p-0">
                    <p class="m-0 resumenPago-moneda">+ {{currency(this.montosPago.montoIVACuotaInscripcion)}}</p>
                  </div>
                  <div class="col-6 p-0">
                    <p class="m-0 resumenPago">
                      {{
                        tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7
                          ? "Costo de contrato"
                          : "Contract cost"
                      }} ( {{DatosPago.tipoTarjetaCD === 0 ? 0 
                          : DatosPago.tipoTarjetaCD === 1 ? DatosPago.tipoPago === 0 ? 2 : 6
                          : 3}} %):
                    </p>
                  </div>
                  <div class="col-3 p-0">
                    <p class="m-0 resumenPago-moneda">+ {{currency(comisionComputed)}}</p>
                  </div>
                  <div class="col-6 p-0">
                    <p class="m-0 resumenPago titulo-seccionPago">
                      {{
                        tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7
                          ? "Total a pagar"
                          : "Total Amount Due"
                      }}:
                    </p>
                  </div>
                  <div class="col-3 p-0">
                    <p class="m-0 text-right titulo-seccionPago">{{currency(this.montosPago.montoTarjetaUnaExhibicion ) }}</p>
                  </div>

                  <div class="col-9 mt-3 botonLigaPago" v-if="cargandoIframeBoton == false">
                    <div class="contenedor-metodo-pago__iframe">
                      <button class=" btn boton-primario" @click="GenerarLigaPagoMIT()"
                      >
                        {{
                          tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7
                            ? "Crear liga de pago"
                            : "Create paid link"
                        }}
                      </button>
                    </div>
                  </div>
                </div>

            </div>
          </div>
        </div>

        <!-- Ifram de pago -->
        <div class="col-lg-6  mt-4" v-if="cargandoIframe">
          <v-progress-circular
            :size="50"
            :width="5"
            color="#b8725a"
            indeterminate
          ></v-progress-circular>
        </div>
        <div class="col-lg-6  mt-3" v-if="mostrarDatosPagoPrevio">
          <div class="contenedor-metodo-pago__pago-previo">
            <i class="fas fa-file-invoice-dollar contenedor-metodo-pago__icono-pago-previo"></i>
            <strong class="contenedor-metodo-pago__titulo-pago"
              >{{
                tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7
                  ? "¡Ya tienes un pago realizado!"
                  : "You have already made a payment!"
              }}
            </strong>
            <div class="text-left w-100 mt-1">
              <label class="pago-previo-label">
                {{
                  tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7
                    ? "Tarjetahabiente: "
                    : "Cardholder: "
                }}
                {{ DatosPagoExitoso.nombretarjetahabiente }}
              </label>
              <br />
              <label class="pago-previo-label">
                {{
                  tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7
                    ? "Tarjeta: "
                    : "Card:"
                }}
                {{ DatosPagoExitoso.numerotarjeta }}
              </label>
              <br />
              <label class="pago-previo-label">
                {{
                  tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7
                    ? "Monto: $"
                    : "Amount: $"
                }}
                {{ DatosPagoExitoso.monto }}
              </label>
              <br />
              <label class="pago-previo-label">
                {{
                  tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7
                    ? "No. Orden: "
                    : "Order number: "
                }}
                {{ DatosPagoExitoso.orden }}
              </label>
              <br />
              <label class="pago-previo-label">
                {{
                  tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7
                    ? "Autorización"
                    : "Authorization"
                }}
                {{ DatosPagoExitoso.tipoTarjetaCD }}
              </label>
              <br />
              <label class="pago-previo-label">
                {{
                  tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7
                    ? "Fecha: "
                    : "Date: "
                }}
                {{ DatosPagoExitoso.fecha }}
              </label>
            </div>
          </div>
        </div>

        <div class="col-lg-6 contenedor-metodo-pago__iframe" v-if="muestraIframeUnaExhibicion">
          <iframe
            @load="DesactivarLoader(), revisarRedirect()"
            class="iframe-pago"
            :src="urlPago"
            ref="iframeContent" 
          ></iframe>
        </div>
        <div class="col-lg-6 contenedor-metodo-pago__iframe" v-if="muestraIframeMSI">
          <iframe
            @load="DesactivarLoader(), revisarRedirect()"
            class="iframe-pago"
            :src="urlPago"
            ref="iframeContent"
          ></iframe>
        </div>

        <div class="col-lg-6 row contenedorBoton" v-if="mostrarMensajePago">
          <div class="col-10 p-0 contenedorBotonPago">
            <div class="center" v-if="mostrarMensajePago == 'Aprobado'">
              <img src="https://hircasageneral.blob.core.windows.net/embajadores-manager/img/images/autorizado.png" alt="autorizado">
              <p class="text-center titulo-seccionPago mb-5">
                {{
                  tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7
                    ? "Tú pago ha sido aprobado"
                    : "Your payment has been approved"
                }}
              </p>
              <p class="text-left resumenPago px-3 mb-1">
                {{
                  tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7
                    ? `Referencia: ${retornoPago[14].split('=')[1]}`
                    : `Reference: ${retornoPago[14].split('=')[1]}`
                }}
              </p>
              <p class="text-left resumenPago px-3 mb-1">
                {{
                  tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7
                    ? `Monto: ${currency(retornoPago[13].split('=')[1])}`
                    : `Amount: ${currency(retornoPago[13].split('=')[1])}`
                }}
              </p>
              <p class="text-left resumenPago px-3 mb-1">
                {{
                  tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7
                    ? `Número de autorización: ${retornoPago[1].split('=')[1]}`
                    : `Authorization number: ${retornoPago[1].split('=')[1]}`
                }}
              </p>
              <p class="text-left resumenPago px-3">
                {{
                  tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7
                    ? `Operación: ${retornoPago[2].split('=')[1]}`
                    : `Transaction: ${retornoPago[2].split('=')[1]}`
                }}
              </p>
            </div>
            <div v-else>
              <img src="https://hircasageneral.blob.core.windows.net/embajadores-manager/img/images/rechazado.png" alt="rechazado">
              <p class="text-center titulo-seccionPago mb-5">
                {{
                  tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7
                    ? "Tú pago ha sido rechazado"
                    : "Your payment has been rejected"
                }}
              </p>
              <p class="text-center resumenPago mb-0">
                {{
                  tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7
                    ? "No se realizó ningún cargo a su tarjeta."
                    : "No charges were made to your card."
                }}
              </p>
              <p class="text-center resumenPago mb-5">
                {{
                  tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7
                    ? "La operación fue rechazada por su banco emisor. Favor de intentar con otra Tarjeta."
                    : "The operation was rejected by its issuing bank. Please try another Card."
                }}
              </p>
              <p class="text-left resumenPago px-3 mb-1">
                {{
                  tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7
                    ? `Respuesta: ${retornoPago[1].split('=')[1]}`
                    : `Reply: Rejected`
                }}
              </p>
              <p class="text-left resumenPago px-3">
                {{
                  tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7
                    ? `Descripción: ${retornoPago[2].split('=')[1]}`
                    : `Description: Declined transaction`
                }}
              </p>
            </div>

            <div v-if="mostrarMensajePago == 'Aprobado'">
              <button v-if="mostrarBotonContinuar" class="btn boton-primario boton-accion-pago contenedor-boton-finaliza-pago__boton" @click="ConfirmaPago()"
              >
                {{
                  tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7
                    ? "Continuar"
                    : "Continue"
                }}
              </button>
            </div>
            <div v-else>
              <button v-if="mostrarBotonContinuar" class="btn boton-primario boton-accion-pago contenedor-boton-finaliza-pago__boton" @click="GenerarLigaPagoMIT()"
              >
                {{
                  tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7
                    ? "Volver a intentar"
                    : "Try again"
                }}
              </button>
            </div>
          </div>
        
        </div>

        
      </div>
    </div>
    
    <div class="container contenedor-metodo-pago mt-2">
      <div class="row row-cols-lg-12">
        <div class="col-lg-12 contenedor-botones-pago">
          <button
            v-if="mostrarBotonRegresar"
            @click="IrAtras()"
            class="
              btn
              boton-transparente boton-accion-pago
              contenedor-boton-finaliza-pago__boton
            "
          >
            {{
              tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7
                ? "Atrás"
                : "Back"
            }}
          </button>
        </div>
      </div>
    </div>
    <div class="container contenedor-metodo-pago">
      <div class="text-center" v-if="mostrarInstruccionesPagoLinea">
        <p class="parrafo-instrucciones-pago w-80 mt-2">
          {{
            tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7
              ? "¿Aún no has realizado tu pago?"
              : "Haven't you made your payment yet?"
          }}
        </p>
        <button
          v-if="mostrarBotonPagoLinea"
          class="btn boton-primario w-50"
          @click="PagarEnLinea()"
        >
          {{
            tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7
              ? "Paga en línea"
              : "Pay online"
          }}
        </button>
        <button v-else class="btn boton-primario w-50" disabled>
          {{
            tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7
              ? "Paga en línea"
              : "Pay online"
          }}
        </button>
      </div>
    </div>
    
  </div>
</template>

<script>
//Rutas API - Embajadores
const rutaMedioPagoEfectivo =
  "/api/Master/SolicitudInscripcion/ObtenerEnumMedioPago";
const rutaMedioPagoLinea =
  "/api/Master/SolicitudInscripcion/ObtenerEnumTipoPago";
const rutaCargarComprobanteDePago =
  "/api/Master/IntegracionExpediente/CargarComprobantesDePagoProspecto";
const rutaProspectoTieneComprobantes =
  "/api/Master/IntegracionExpediente/ProspectoTieneComprobantesPago";
const rutaSubirComprobantePago =
  "/api/Master/IntegracionExpediente/CrearArchivoComprobanteDePagoProspecto";
const rutaCargarMontosDePago =
  "/api/Master/SolicitudInscripcion/CargarMontosDePagoProspecto";
const rutaDescargarArchivo = "/api/Master/Archivo/DescargarArchivo";
const rutaEliminarArchivo = "/api/Master/Archivo/EliminarArchivo";
const rutaEnviarComprobantePago =
  "/api/Master/IntegracionExpediente/TerminarSubirComprobanteDePago";
const rutaConsultarObservacionComprobante =
  "/api/Master/PreAutorizacion/ConsultarObservacionArchivo";
const rutaConsultaConfiguracionModulo =
  "/api/Master/Master/ConsultaConfiguracionModulo";
const rutaConsultarReferenciaPago =
  "/api/Master/PreAutorizacion/ConsultarReferenciaPago";
const rutaActualizarReferenciaPago =
  "/api/Master/PreAutorizacion/ActualizarReferenciaPago";
const rutaCreaReferenciaPago = "/api/Master/PreAutorizacion/CreaReferenciaPago";
const rutaRegistrarPagoEnLinea =
  "/api/Master/SolicitudInscripcion/RegistrarPagoEnLinea";
const rutaActualizarEtapaPorPagoEnLinea =
  "/api/Master/IntegracionExpediente/ActualizarEtapaPorPagoEnLinea";


//Rutas API Pago MIT
const rutaGenerarLigaDePago =
  process.env.VUE_APP_PAGOS_MIT + "/GenerarLigaPagoSinContrato";
const rutaConsultarLigaPago =
  process.env.VUE_APP_PAGOS_MIT + "/ObtenerLigaPago";
const rutaConsultarDetallePago =
  process.env.VUE_APP_PAGOS_MIT + "/ObtenerRespuestaPago";

//Rutas ambiente
const ambiente = process.env.VUE_APP_ENTORNO;

//Plugins
import axios from "axios";
import servicios from "../../../servicios/service.js";
import mixinSolicitudInscripcion from "../Mixins/MixinSolicitudInscripcion";

//Componentes
import DropDown from "../components/DropDown.vue";
import TituloSeccion from "../../../Componentes/TituloSeccion.vue";
import InputDocumentos from "../components/InputDocumentos.vue";
import ModalObservacion from "../components/ModalObservacion.vue";

//Variables y Constantes Usuario
const EnIngles = {
  params: {
    enIngles: null
  }
};
export default {
  name: "CargarInformacionDePago",
  components: {
    DropDown,
    TituloSeccion,
    InputDocumentos,
    ModalObservacion
  },
  mixins: [mixinSolicitudInscripcion],
  data() {
    return this.InitialState();
  },

  async mounted() {
    var thisVue = this;
    thisVue.ProspectoId = this.$store.getters.prospectoId;
    thisVue.TipoUsuario = parseInt(sessionStorage.getItem("tipoUsuario"));
    thisVue.tipoPersona = this.$store.getters.tipoPersona;
    thisVue.modoPago = this.$store.getters.modoPago;
    this.ProspectoId = this.$store.getters.prospectoId;

    this.enviandoComprobante = false;

    this.urlPago = "";

    this.DatosPersonales = (
      await this.ObtenerDatosProspecto(this.ProspectoId)
    ).data.data;

    this.NombreCompletoProspecto =
      this.DatosPersonales.nombres +
      " " +
      this.DatosPersonales.apellidoPaterno +
      " " +
      this.DatosPersonales.apellidoMaterno;

    if (this.TipoUsuario == 3) {
      this.mostrarBotonPagoLinea = true;
    } else {
      this.mostrarBotonPagoLinea = false;
      this.mostrarBotonContinuar = false;
    }

    if (this.ProspectoId > 0) {
      //REVISAR: Existo log para identificar en que momento se llama al método
      this.ValidarPagoPrevioRealizado();
      if (!this.PagoRealizado) {
        this.ObtenerMontosPago();
        if (this.modoPago == 2) {
          this.mostrarmediosPagoEfectivo = false;
          this.mostrarInstruccionesPagoLinea = false;
          this.mostrarBotonRegresar = true;
          this.muestramediosPagoLinea = true;
          this.CargarMediosPagoLinea(
            this.tipoPersona != 2 &&
              this.tipoPersona != 5 &&
              this.tipoPersona != 7
              ? false
              : true
          );
        } else {
          this.ConsultaConfiguracionModulo();
          this.CargarMediosPagoEfectivo(
            this.tipoPersona != 2 &&
              this.tipoPersona != 5 &&
              this.tipoPersona != 7
              ? false
              : true
          );
        }
      }
    }

    this.catalogos.tipoMoneda = [{"text":"Pesos","value":0}]
    this.catalogos.tipoTarjetaCD = this.tipoPersona != 2 && this.tipoPersona != 5 && this.tipoPersona != 7
      ? [{"text":"Débito Nacional","value":0},{"text":"Crédito Nacional","value":1},{"text":"Internacional","value":2}]
      : [{"text":"Debit MXN","value":0},{"text":"Credit MXN","value":1},{"text":"International payment","value":2}]
  },
  methods: {
    inglesEval(){
      return this.tipoPersona != 2 && this.tipoPersona != 5 && this.tipoPersona != 7
          ? false
          : true
    },
    InitialState() {
      return {
        montoSinDescuento: 0,
        retornoPago: null,
        mostrarMensajePago: null,
        referenciaPagoLinea: null,
        autorizacionPagoLinea: null,
        mostrarHojaPrueba: false,
        soloLectura: false,
        tries: 0,
        configuraciones: {
          configuracionId: null,
          moduloId: null,
          nombre: null,
          descripcion: null,
          regla: null,
          mensaje: null,
          activo: null,
          fechaAlta: null
        },
        //Datos el prospecto/usuario
        tipoPersona: null,
        TipoUsuario: null,
        ProspectoId: null,
        //Manejo de vistas
        muestraCargaComprobante: false,
        mostrarInstruccionesPagoLinea: true,
        muestramediosPagoLinea: false,
        mostrarmediosPagoEfectivo: true,
        muestraIframeUnaExhibicion: false,
        muestraIframeMSI: false,
        mostrarBotonPagoLinea: false,
        mostrarBotonRegresar: false,
        mostrarBotonContinuar: false,
        mostrarDatosPagoPrevio: false,
        mostrarTextoPagoNoProcesado: false,
        //Datos del prospecto
        DatosPersonales: {
          nombre: null,
          apellidoPaterno: null,
          apellidoMaterno: null,
          telefonoCelular: null,
          correoElectronico: null
        },
        ContratosLigaPago: [
          {
            contratoId: 0,
            fondeo: 0,
            referenciaUnica: "",
            monto: 0
          }
        ],

        InformacionPago: {
          referenciaId: 0,
          referenciaPago: "",
          LigaId: "",
          SolicitudCadenaXML: "",
          RespuestaLigaPago: "",
          RespuestaPago: "",
          NotificacionPagoSolicitante: "",
          LigaResultadoOrigen: "",
          FolioPago: "",
          TipoPago: "",
          tipoMoneda:"",
          EstatusLigaPago: null,
          Aplicacion: null,
          FechaCreacion: "",
          FechaAplicacionPago: "",
          NombreCliente: "",
          ContratosLigaPago: [
            {
              contratoId: 0,
              fondeo: 0,
              referenciaUnica: "",
              monto: 0
            }
          ]
        },
        //Catalogos
        catalogos: {
          mediosPagoLinea: [],
          tipostarjeta: [],
          mediosPagoEfectivo: [],
          tipoMoneda:[],
          tipoTarjetaCD:[]
        },
        //Datos del pago
        comisionTPV: 0,
        comisionTPVUnaEx: 0,
        comisionTPVTresMeses: 0,
        montoPagoRequest: 0,
        modoPago: null,
        pagoId: null,
        DatosPago: {
          tipoPago: null,
          tipoMedioPago: null,
          tipoMoneda: 1,
          tipoTarjetaCD: null
        },
        DatosPagoExitoso: {
          nombretarjetahabiente: null,
          numerotarjeta: null,
          monto: null,
          orden: null,
          tipoTarjetaCD: null,
          fecha: null
        },
        urlPago: null,
        montosPago: null,
        submontosPago: null,
        comprobantesCargados: [
          {
            archivoId: null,
            nombreOriginal: null,
            esAprobado: true,
            archivo: null
          }
        ],
        RespuestaPago: {
          LigaId: "",
          ReferenciaPago: "",
          FolioPago: "",
          EstatusLigaPago: 0,
          Hora: "",
          Fecha: "",
          tipoTarjetaCD: "",
          TipoOperacion: "",
          Monto: "",
          TerminacionTarjeta: ""
        },
        ProspectoTieneComprobantes: false,
        ObservacionComprobante: "",
        pagoExitoso: false,
        PagoRealizado: false,
        //Loaders
        enviandoComprobante: false,
        cargandoIframe: false,
        cargandoIframeBoton: false
      };
    },
    IrAtras() {
      if (this.muestramediosPagoLinea == true) {
        this.muestramediosPagoLinea = false;
        this.mostrarInstruccionesPagoLinea = true;
        this.mostrarmediosPagoEfectivo = true;
        this.muestraIframeUnaExhibicion = false;
        this.muestraIframeMSI = false;
        this.urlPago = null;
        this.DatosPago.tipoPago = null;
        this.DatosPago.tipoMoneda = 1;
        this.DatosPago.tipoTarjetaCD = null;
        this.mostrarBotonRegresar = false;
        if (this.DatosPago.tipoMedioPago != null)
          this.muestraCargaComprobante = true;
      } else if (this.muestraCargaComprobante == true) {
        this.DatosPago.tipoMedioPago = null;
        this.muestraCargaComprobante = false;
        this.mostrarInstruccionesPagoLinea = true;
        this.mostrarBotonRegresar = false;
      }
    },
    DesactivarLoader() {},
    revisarRedirect() {
      let frame = this.$refs.iframeContent.contentWindow.location.search ? this.$refs.iframeContent.contentWindow.location.search : null
      let referencia, nuAutorizacion
      // Iframe aceptado
      //let frame = "?success=true&nuAut=649785&operacion=698065323&fecha=26%2F09%2F23%2022%3A39%3A15&banco=BBVA&marca=Visa&tpTdc=D&nb_merchant=8872367&promocion=C&nbResponse=Aprobado&nb_adquirente=getnet&sucursal=0001&empresa=HIR%20CASA&importe=0.02&referencia=5abb9ec0-1019-44a0-a009-57f33ab6aa7a&referenciaPayment=5abb9ec0-1019-44a0-a009-57f33ab6aa7a&nbMoneda=MXN&cdEmpresa=V71B&urlTokenId=HZ4U7USQ&idLiga=HZ4U7USQ&email="
      // iFrame negativo
      //let frame ="?success=true&nbResponse=Rechazado&cdResponse=Transaccion%20declinada&nb_error=La%20tarjeta%20no%20puede%20ser%20procesada%20con%20afiliacion%20en%20dolares&sucursal=0008&empresa=HIR%20CASA&importe=300.00&referencia=84a57ef7-7d39-4f58-917f-4cf724d96c80&referenciaPayment=84a57ef7-7d39-4f58-917f-4cf724d96c80&nbMoneda=USD&cdEmpresa=V71B&urlTokenId=89GVZKWX&idLiga=89GVZKWX&email="
      // iFrame error
      //let frame ="?success=true&nbResponse=Rechazado&cdResponse=Transaccion%20declinada&nb_error=La%20tarjeta%20no%20puede%20ser%20procesada%20con%20afiliacion%20en%20dolares&sucursal=0008&empresa=HIR%20CASA&importe=300.00&referencia=84a57ef7-7d39-4f58-917f-4cf724d96c80&referenciaPayment=84a57ef7-7d39-4f58-917f-4cf724d96c80&nbMoneda=USD&cdEmpresa=V71B&urlTokenId=89GVZKWX&idLiga=89GVZKWX&email="
      if(frame != null) {
        let searchCompleto = decodeURI(frame)
        this.retornoPago = searchCompleto.split('&')
        if(searchCompleto.split('&').length > 14) {
          nuAutorizacion = this.retornoPago[1].split('=')[1]
          referencia = this.retornoPago[14].split('=')[1]
          this.mostrarMensajePago = this.retornoPago[9].split('=')[1]
          this.muestraIframeUnaExhibicion = null
          this.muestraIframeMSI = null
        } else {
          referencia = this.retornoPago[7].split('=')[1]
          this.mostrarMensajePago = this.retornoPago[1].split('=')[1]
          this.muestraIframeUnaExhibicion = null
          this.muestraIframeMSI = null
        }
        this.referenciaPagoLinea = referencia
        this.autorizacionPagoLinea = nuAutorizacion
        if (this.mostrarMensajePago === "Aprobado") {
          this.GuardarReferenciaPagoLinea();
        }
      }
      

    },
    CargarMediosPagoEfectivo(enIngles) {
      EnIngles.params.enIngles = enIngles;
      axios
        .get(rutaMedioPagoEfectivo, EnIngles)
        .then(resp => {
          if (resp.data.estado === 0)
            this.catalogos.mediosPagoEfectivo = resp.data.data;
          this.catalogos.mediosPagoEfectivo.forEach(
            t => (t.value = Number(t.value))
          );
          this.catalogos.mediosPagoEfectivo = this.catalogos.mediosPagoEfectivo.filter(
            t => t.value < 2
          );
        })
        .catch(e => {
          this.ManejarExcepcion(e);
        });
    },
    CargarMediosPagoLinea(enIngles) {
      EnIngles.params.enIngles = enIngles;
      axios
        .get(rutaMedioPagoLinea, EnIngles)
        .then(resp => {
          if (resp.data.estado === 0) {
            this.catalogos.mediosPagoLinea = resp.data.data;
            if (ambiente == "produccion")
              this.catalogos.mediosPagoLinea = this.catalogos.mediosPagoLinea.filter(
                p => p.value == "0"
              ); //Temporal hasta que se habilite la opción de pago a meses en producción
            this.catalogos.mediosPagoLinea.forEach(
              m => (m.value = Number(m.value))
            );
          }
        })
        .catch(e => this.ManejarExcepcion(e));
    },
    TerminarPagoEnLinea() {
      switch (this.tipoPersona) {
        case 0:
        case 3:
        case 4:
        case 6:
          this.$router.push({ path: "HojaPrueba" });
          break;
        case 1:
          this.$router.push({ path: "HojaPruebaMoral" });
          break;
        case 2:
        case 5:
        case 7:
          this.$router.push({ path: "HojaPruebaExtranjero" });
          break;
      }
    },
    ConsultarProspectoTieneComprobantes() {
      const prospecto = {
        params: {
          ProspectoId: this.ProspectoId
        }
      };
      axios
        .get(rutaProspectoTieneComprobantes, prospecto)
        .then(resp => {
          if (resp.data.estado === 0) {
            this.ProspectoTieneComprobantes = resp.data.data;
            if (this.ProspectoTieneComprobantes) {
              if (this.mostrarTextoPagoNoProcesado)
                this.mostrarTextoPagoNoProcesado = false;
              this.mostrarmediosPagoEfectivo = false;
              this.muestraCargaComprobante = true;
              this.mostrarInstruccionesPagoLinea = false;
              this.modoPago = 1;
              this.cargarComprobantesDePagoProspecto();
              this.PagoRealizado = true;
            }
          } else if (resp.data.estado === 1) {
            this.AlertaEmbajadores(resp.data.mensaje, true, this.inglesEval());
          }
        })
        .catch(e => {
          this.ManejarExcepcion(e);
        });
    },
    cargarComprobantesDePagoProspecto() {
      const parametroProspectoId = {
        params: {
          ProspectoId: this.ProspectoId
        }
      };
      axios
        .get(rutaCargarComprobanteDePago, parametroProspectoId)
        .then(resp => {
          if (resp.data.estado === 0) {
            let arregloComprobantes = resp.data.data;
            if (arregloComprobantes.length > 0) {
              this.comprobantesCargados = [];
              for (var item of arregloComprobantes) {
                let comprobante = {
                  archivoId: item.archivoId,
                  nombreOriginal: item.nombreOriginal,
                  documento: item.documento,
                  esAprobado: item.esAprobado
                };
                this.comprobantesCargados.push(comprobante);
              }
              this.$forceUpdate();
            } else {
              this.comprobantesCargados = [];
              this.comprobantesCargados = [
                {
                  archivoId: null,
                  nombreOriginal: null,
                  esAprobado: true,
                  archivo: null
                }
              ];
            }
          } else if (resp.data.estado === 1) {
            this.AlertaEmbajadores(resp.data.mensaje, true, this.inglesEval());
          }
        })
        .catch(e => {
          this.ManejarExcepcion(e);
        });
    },
    EnviarComprobantePago() {
      this.enviandoComprobante = true;
      if (this.ProspectoId != null) {
        this.modoPago = 1;
        this.$store.commit("setModoPago", this.modoPago);
        var paqueteDeDatos = new FormData();
        paqueteDeDatos.append("prospectoId", this.ProspectoId);
        axios
          .post(rutaEnviarComprobantePago, paqueteDeDatos)
          .then(resp => {
            if (resp.data.estado === 0) {
              this.enviandoComprobante = false;
              if (
                this.TipoUsuario == 3 ||
                this.TipoUsuario == 6 ||
                this.TipoUsuario == 8 ||
                this.TipoUsuario == 9
              ) {
                //redirección a hoja de prueba
                switch (this.tipoPersona) {
                  case 0:
                    this.$store.commit("comprobantePagoEnviado", true);
                    this.$router.push({ path: "HojaPrueba" });
                    break;
                  case 1:
                    this.$store.commit("comprobantePagoEnviado", true);
                    this.$router.push({ path: "HojaPruebaMoral" });
                    break;
                  case 2:
                    this.$store.commit("comprobantePagoEnviado", true);
                    this.$router.push({ path: "HojaPruebaExtranjero" });
                    break;
                }
              } else {
                this.AlertaEmbajadores(
                  this.tipoPersona != 2 &&
                    this.tipoPersona != 5 &&
                    this.tipoPersona != 7
                    ? "Tu comprobante de pago fue enviado correctamente."
                    : "Your payment voucher was successfully sent.",
                  true,
                  this.inglesEval()
                );
                this.$router.push({
                  name: "AdministracionDeProspectos"
                });
              }
            } else if (resp.data.estado === 1) {
              this.enviandoComprobante = false;
              this.AlertaEmbajadores(resp.data.mensaje, true, this.inglesEval());
            }
          })
          .catch(e => {
            this.enviandoComprobante = false;
            this.ManejarExcepcion(e);
          });
      }
    },
    almacenarArchivoComprobante(event, index) {
      this.comprobantesCargados[index].archivo = event.target.files[0];
      this.SubirComprobantePago(index);
    },
    activaInputComprobantePago(index) {
      this.$refs.inputComprobantePago[index].click();
    },
    MostrarInputsNuevoComprobante() {
      this.comprobantesCargados.push({
        archivoId: null,
        nombreOriginal: null,
        esAprobado: true,
        archivo: null
      });
    },
    SubirComprobantePago(index) {
      if (this.ProspectoId != null) {
        if (this.comprobantesCargados[index].archivoId != null) {
          if (this.comprobantesCargados[index].archivo === null) {
            this.AlertaEmbajadores(
              this.tipoPersona == 2 ||
                this.tipoPersona == 5 ||
                this.tipoPersona == 7
                ? "You must select a file."
                : "Debes seleccionar un archivo.",
              true,
              this.inglesEval()
            );
            return;
          }
        }

        if (
          !servicios.validarFormatoArchivoValido(
            this.comprobantesCargados[index].archivo
          )
        ) {
          this.AlertaEmbajadores(
            this.tipoPersona == 2 ||
              this.tipoPersona == 5 ||
              this.tipoPersona == 7
              ? "The file format you have selected is invalid."
              : "El formato del archivo que seleccionaste no es válido.",
            true,
            this.inglesEval()
          );
          return;
        }

        if (
          !servicios.validarTamanioArchivoValido(
            this.comprobantesCargados[index].archivo
          )
        ) {
          this.AlertaEmbajadores(
            this.tipoPersona == 2 ||
              this.tipoPersona == 5 ||
              this.tipoPersona == 7
              ? "The file you have selected is too large."
              : "El archivo que seleccionaste es demasiado grande.",
            true,
            this.inglesEval()
          );
          return;
        }

        var paqueteDeDatos = new FormData();
        if (this.comprobantesCargados[index].archivoId != null) {
          paqueteDeDatos.append(
            "archivoId",
            this.comprobantesCargados[index].archivoId
          );
        }
        paqueteDeDatos.append("prospectoId", this.ProspectoId);
        paqueteDeDatos.append(
          "archivo",
          this.comprobantesCargados[index].archivo
        );
        axios
          .post(rutaSubirComprobantePago, paqueteDeDatos)
          .then(resp => {
            if (resp.data.estado === 0) {
              this.AlertaEmbajadores(
                this.tipoPersona == 2 ||
                  this.tipoPersona == 5 ||
                  this.tipoPersona == 7
                  ? "File was successfully saved."
                  : "El archivo fue cargado exitosamente.",
                true,
                this.inglesEval()
              );
              this.cargarComprobantesDePagoProspecto();
            } else if (resp.data.estado === 1) {
              this.AlertaEmbajadores(resp.data.mensaje, false, this.inglesEval());
            }
          })
          .catch(e => {
            this.ManejarExcepcion(e);
          });
      }
    },
    descargarArchivo(archivoId) {
      window.location.href = rutaDescargarArchivo + "?archivoId=" + archivoId;
    },
    eliminarArchivo(archivoId) {
      this.$fire({
        title: "Eliminar archivo",
        html:
          this.tipoPersona != 2 &&
          this.tipoPersona != 5 &&
          this.tipoPersona != 7
            ? "<br>Estás por eliminar este archivo<br>" +
              "¿Deseas continuar?<br>"
            : "<br>You are about to delete this file<br>" +
              "Do you want to continue?<br>",
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText:
          this.tipoPersona != 2 &&
          this.tipoPersona != 5 &&
          this.tipoPersona != 7
            ? "Aceptar"
            : "Accept",
        cancelButtonText:
          this.tipoPersona != 2 &&
          this.tipoPersona != 5 &&
          this.tipoPersona != 7
            ? "Cancelar"
            : "Cancel",
        allowOutsideClick: true
      }).then(result => {
        if (result.value) {
          if (archivoId != 0 && archivoId != null) {
            var paqueteDeDatos = new FormData();
            paqueteDeDatos.append("archivoId", archivoId);
            axios
              .post(rutaEliminarArchivo, paqueteDeDatos)
              .then(resp => {
                if (resp.data.estado === 0) {
                  this.$fire({
                    title: resp.data.mensaje,
                    confirmButtonText: this.tipoPersona != 2 && this.tipoPersona != 5 && this.tipoPersona != 7 ? "Aceptar" : "Accept"
                  });
                  this.cargarComprobantesDePagoProspecto();
                } else if (resp.data.estado === 1) {
                  this.AlertaEmbajadores(resp.data.mensaje, true, this.inglesEval());
                }
              })
              .catch(e => {
                this.ManejarExcepcion(e);
              });
          }
          this.cargarComprobantesDePagoProspecto();
        }
      });
    },
    VerObservacionComprobante(archivoId) {
      const archivo = {
        params: {
          entidadId: archivoId,
          tipoEntidad: 0
        }
      };
      axios
        .get(rutaConsultarObservacionComprobante, archivo)
        .then(resp => {
          if (resp.data.estado === 0) {
            this.ObservacionComprobante = resp.data.data.resultado;
          }
        })
        .catch(e => {
          this.ManejarExcepcion(e);
        });
    },
    ConsultaConfiguracionModulo() {
      axios
        .get(rutaConsultaConfiguracionModulo)
        .then(resp => {
          if (resp.data.estado === 0) {
            this.configuraciones = resp.data.data;
          }
        })
        .catch(e => {
          this.ManejarExcepcion(e);
        });
    },
    PagarEnLinea() {
      if (this.mostrarTextoPagoNoProcesado)
        this.mostrarTextoPagoNoProcesado = false;
        this.mostrarBotonRegresar = true;
        this.mostrarmediosPagoEfectivo = false;
        this.muestramediosPagoLinea = true;
        this.muestraCargaComprobante = false;
        this.mostrarInstruccionesPagoLinea = false;
        this.CargarMediosPagoLinea(
        this.tipoPersona != 2 && this.tipoPersona != 5 && this.tipoPersona != 7
          ? false
          : true
      );
    },
    ObtenerMontosPago() {
      const prospecto = {
        params: {
          prospectoId: this.ProspectoId
        }
      };
      axios
        .get(rutaCargarMontosDePago, prospecto)
        .then(resp => {
          this.montosPago = JSON.parse(JSON.stringify(resp.data.data.datosPago));
          this.submontosPago = JSON.parse(JSON.stringify(resp.data.data.datosPago));

          let calcularCI = this.montosPago.montoContrato * this.montosPago.porcentajeCuotaInscripcion;

          this.montoSinDescuento = calcularCI;
        })
        .catch(e => this.ManejarExcepcion(e));
    },
    //MIT
    GenerarLigaPagoMIT() {
      this.cargandoIframe = true;
      this.cargandoIframeBoton = true;
      let tipoCargo, montoAPagar
      switch (this.DatosPago.tipoPago) {
        case 0:
          this.muestraIframeMSI = false;
          this.muestraIframeUnaExhibicion = true;
          break;
        case 1:
        case 2:
          this.muestraIframeUnaExhibicion = false;
          this.muestraIframeMSI = true;
          break;
      }
      //tipoPago = 0 -> Contado
      if(this.DatosPago.tipoPago === 0 ){
        tipoCargo = 0
        montoAPagar=this.montosPago.montoTarjetaUnaExhibicion;
      } else {
        tipoCargo = 2
        montoAPagar=this.montosPago.montoTarjetaUnaExhibicion;
      }
      //monto: montoAPagar,
      let objetoPago = {
        monto: montoAPagar,
        clienteId: this.ProspectoId,        
        nombreCliente: `${this.DatosPersonales.nombres} ${this.DatosPersonales.apellidoPaterno} ${this.DatosPersonales.apellidoMaterno}`,
        emailCliente: this.DatosPersonales.correo,
        telefonoCliente: this.DatosPersonales.telefono,
        formaPago: this.DatosPago.tipoPago,//CONTADO,MESES3
        tipoCargo: tipoCargo,//CARGO_DIRECTO_MXN = 0,MSI=2
        tipoPago: 1,//RECIBO,CI
        aplicacion: 0,//EMBAJADORES
      };
      
      axios
      .post(rutaGenerarLigaDePago, objetoPago)
      .then(resp => {
        this.urlPago = resp.data.ligaPagoMIT;
        this.cargandoIframe = false;
      })
      .catch(e => {
        console.log(e);
        this.cargandoIframe = false;
        this.ManejarExcepcion(e);
      });
    },

    //Paso Metodo de Pago MIT
    //REVISAR: Posible no se usa
    ValidarPagoPrevioRealizado() {
      //this.ConsultaReferenciaPago();//ale  
      console.log("ValidarPagoPrevioRealizado");
      if (this.referenciaId > 0) {
        this.ConsultaLigaPago();
      }

      if (this.InformacionPago.ligaId == 0) {
        switch (this.InformacionPago.estatusLigaPago) {
          case 0:
            this.PagoRealizado = false;
            this.urlPago = this.InformacionPago.ligaPagoMIT;
            break;
          case 1:
          case 2:
            this.PagoRealizado = true;
            this.MostrarDatosPagoExistenteAprobado();
            break;
          case 3:
          case 4:
            this.PagoRealizado = false;
            this.MostrarDatosPagoExistenteAprobado();
            break;
        }
      } else {
        this.mostrarTextoPagoNoProcesado = false;
        this.ConsultarProspectoTieneComprobantes();
      }
    },
    MostrarDatosPagoExistenteAprobado() {
      this.DatosPagoExitoso.nombretarjetahabiente = this.NombreCompletoProspecto;
      this.DatosPagoExitoso.numerotarjeta = this.RespuestaPago.terminacionTarjeta;
      this.DatosPagoExitoso.monto = this.RespuestaPago.monto;
      this.DatosPagoExitoso.orden = this.RespuestaPago.folioPago;
      this.DatosPagoExitoso.tipoTarjetaCD = this.RespuestaPago.tipoTarjetaCD;
      this.DatosPagoExitoso.fecha =
        this.RespuestaPago.fecha + " " + this.RespuestaPago.hora;
      this.mostrarmediosPagoEfectivo = false;
      this.mostrarInstruccionesPagoLinea = false;
      this.mostrarDatosPagoPrevio = true;

      if (this.TipoUsuario == 3) {
        this.mostrarBotonContinuar = true;
      } else {
        this.mostrarBotonContinuar = false;
      }
    },
    //REVISAR: No se usa
    CreaReferenciaPago() {
      const ReferenciaPago = {
        params: {
          prospectoId: this.ProspectoId,
          referenciaPago: this.referenciaPago,
          AplicacionId: 0
        }
      };
      axios
        .post(rutaCreaReferenciaPago, ReferenciaPago)
        .then(resp => {
          if (resp.data.estado === 0) {
            this.referenciaId = resp.data.data.referenciaId;
            this.referenciaPago = resp.data.data.referencia;
          } else if (resp.data.estado === 2) {
            this.GenerarLigaPagoMIT(this.tipoPago);
          }
        })
        .catch(e => {
          this.ManejarExcepcion(e);
        });
    },
    ActualizaReferenciaPago() {
      const ReferenciaPago = {
        params: {
          prospectoId: this.ProspectoId,
          referenciaPago: this.referenciaPago,
          AplicacionId: 0
        }
      };
      axios
        .post(rutaActualizarReferenciaPago, ReferenciaPago)
        .then(resp => {
          if (resp.data.estado === 0) {
            this.referenciaId = resp.data.data.referenciaId;
            this.referenciaPago = resp.data.data.referencia;
          } else if (resp.data.estado === 2) {
            this.GenerarLigaPagoMIT();//ale
            //this.GenerarLigaPagoMIT(this.tipoPago);
          }
        })
        .catch(e => {
          this.ManejarExcepcion(e);
        });
    },
    ConsultaReferenciaPago() {
      const ReferenciaPago = {
        params: { prospectoId: this.ProspectoId, AplicacionId: 0 }
      };
      axios
        .get(rutaConsultarReferenciaPago, ReferenciaPago)
        .then(resp => {
          if (resp.data.estado === 0) {
            this.referenciaId = resp.data.data.referenciaId;
            this.referenciaPago = resp.data.data.referencia;
          }
        })
        .catch(e => {
          this.ManejarExcepcion(e);
        });
    },
    //REVISAR: No se usa
    ConsultaLigaPago() {
      //const referenciaLigaPago = this.ConsultaReferenciaPago();
      axios
        .get(rutaConsultarLigaPago, this.referenciaPago)
        .then(resp => {
          if (resp.data.estado === 0) {
            this.InformacionPago = resp.data.data;
          }
        })
        .catch(e => {
          this.ManejarExcepcion(e);
        });
    },
    ConsultaPago() {
      const referenciaLigaPago = this.ConsultaReferenciaPago();
      axios
        .get(rutaConsultarDetallePago, referenciaLigaPago)
        .then(resp => {
          if (resp.data.estado === 0) {
            this.RespuestaPago = resp.data.data;
          }
        })
        .catch(e => {
          this.ManejarExcepcion(e);
        });
    },
    async GuardarReferenciaPagoLinea() {
      axios
        .post(rutaRegistrarPagoEnLinea, {referenciaPago: this.referenciaPagoLinea, autorizacionPago:this.autorizacionPagoLinea, prospectoId: this.ProspectoId})
        .then(resp => {
          if (resp.data.estado === 0) {
            this.ActualizarEtapaPorPagoEnLinea();
          } else if (resp.data.estado === 1) {
            this.AlertaEmbajadores(resp.data.mensaje, true, this.inglesEval());
          }
        })
        .catch(e => {
          console.log("cath: " + e);
          this.ManejarExcepcion(e);
        });
    },
    async ActualizarEtapaPorPagoEnLinea() {
    try {
        console.log("Entre al método ActualizarEtapaPorPagoEnLinea");
        let response = await axios.post(`${rutaActualizarEtapaPorPagoEnLinea}?prospectoId=${this.ProspectoId}`);
        if (response.data.estado === 0) {
          this.mostrarHojaPrueba = true;
          console.log("Entre al if del método ActualizarEtapaPorPagoEnLinea y el valor es: " + this.mostrarHojaPrueba );
        }
      console.log("No entro al if de del método ActualizarEtapaPorPagoEnLinea");
      } catch (error) {
        console.log("No se pudo error del método ActualizarEtapaPorPagoEnLinea");
      this.ManejarExcepcion(error);
      }
    },

    ConfirmaPago() {
      if(this.mostrarHojaPrueba){
        if (
        this.TipoUsuario == 3 ||
        this.TipoUsuario == 6 ||
        this.TipoUsuario == 8 ||
        this.TipoUsuario == 9
        ) {
          //redirección a hoja de prueba
          switch (this.tipoPersona) {
          case 0:
          this.$router.push({ path: "HojaPrueba" });
          break;
          case 1:
          this.$router.push({ path: "HojaPruebaMoral" });
          break;
          case 2:
          this.$router.push({ path: "HojaPruebaExtranjero" });
          break;
          }
        }
      } else {
          if (
          this.TipoUsuario == 3 ||
          this.TipoUsuario == 6 ||
          this.TipoUsuario == 8 ||
          this.TipoUsuario == 9
          ) {
            //redirección a hoja de prueba
            switch (this.tipoPersona) {
            case 0:
            this.AlertaEmbajadores('Su pago fue exitoso, pero hubo un inconveniente al reflejarlo en la plataforma. Por favor, contacte al gerente o administrador para resolverlo.',true, this.inglesEval());
            break;
            case 1:
            this.AlertaEmbajadores('Su pago fue exitoso, pero hubo un inconveniente al reflejarlo en la plataforma. Por favor, contacte al gerente o administrador para resolverlo.',true, this.inglesEval());
            break;
            case 2:
            this.AlertaEmbajadores('Your payment was successful, but there was an issue reflecting it on the platform. Please contact the manager or administrator to resolve it.',true, this.inglesEval());
            break;
            }
          }
      }
    },
    //pasar a herlpers globales despues de controlar esto
    currency(number){
        return new Intl.NumberFormat('en-US', {style: 'currency',currency: 'USD', minimumFractionDigits: 2}).format(number);
    }
    //Metodos Validacion Pago
  },
  watch: {
    "DatosPago.tipoTarjetaCD": function() {
      this.mostrarMensajePago = null
      this.cargandoIframeBoton = false
      this.muestraIframeUnaExhibicion = null
      this.muestraIframeMSI = null
      switch (this.DatosPago.tipoTarjetaCD) {
        case 0:
          this.DatosPago.tipoPago = 0
          this.catalogos.mediosPagoLinea = this.tipoPersona != 2 && this.tipoPersona != 5 && this.tipoPersona != 7
            ? [{"disabled":false,"group":null,"selected":false,"text":"UNA EXHIBICIÓN","value":0}]
            : [{"disabled":false,"group":null,"selected":false,"text":"ONE-TIME PAYMENT","value":0}]
          this.montosPago.montoTarjetaUnaExhibicion = this.submontosPago.montoTarjetaUnaExhibicion + (this.submontosPago.montoTarjetaUnaExhibicion * 0)
          break;
        case 1:
          this.DatosPago.tipoPago = 0
          this.catalogos.mediosPagoLinea = this.tipoPersona != 2 && this.tipoPersona != 5 && this.tipoPersona != 7
            ? [{"disabled":false,"group":null,"selected":false,"text":"UNA EXHIBICIÓN","value":0},{"disabled":false,"group":null,"selected":false,"text":"3 MESES SIN INTERESES","value":1}]
            : [{"disabled":false,"group":null,"selected":false,"text":"ONE-TIME PAYMENT","value":0},{"disabled":false,"group":null,"selected":false,"text":"3 INTEREST-FREE MONTHLY PAYMENTS","value":1}]
          
          if(this.DatosPago.tipoPago === 0){
            this.montosPago.montoTarjetaUnaExhibicion = this.submontosPago.montoTarjetaUnaExhibicion + (this.submontosPago.montoTarjetaUnaExhibicion * 0.02)
          } else if(this.DatosPago.tipoPago === 1){
            this.montosPago.montoTarjetaUnaExhibicion = this.submontosPago.montoTarjetaUnaExhibicion + (this.submontosPago.montoTarjetaUnaExhibicion * 0.06)
          }
          break;
        case 2:
          this.DatosPago.tipoPago = 0
          this.catalogos.mediosPagoLinea = this.tipoPersona != 2 && this.tipoPersona != 5 && this.tipoPersona != 7
            ? [{"disabled":false,"group":null,"selected":false,"text":"UNA EXHIBICIÓN","value":0}]
            : [{"disabled":false,"group":null,"selected":false,"text":"ONE-TIME PAYMENT","value":0}]
          this.montosPago.montoTarjetaUnaExhibicion = this.submontosPago.montoTarjetaUnaExhibicion + (this.submontosPago.montoTarjetaUnaExhibicion * 0.03)
      
          break;
      }
    },
    "DatosPago.tipoMedioPago": function() {
      if (this.mostrarTextoPagoNoProcesado)
        this.mostrarTextoPagoNoProcesado = false;
      if (this.DatosPago.tipoMedioPago != null) {
        this.pagoExitoso = false;
        this.mostrarBotonRegresar = false;
        this.muestraCargaComprobante = true;
        this.cargarComprobantesDePagoProspecto();
      }
    },
    "DatosPago.tipoPago": function() {
      this.mostrarMensajePago = null
      this.cargandoIframeBoton = false
      this.muestraIframeUnaExhibicion = false
      this.muestraIframeMSI = false
      if (this.mostrarTextoPagoNoProcesado)
        this.mostrarTextoPagoNoProcesado = false;
      if (this.DatosPago.tipoPago != null) {
        if (this.TipoUsuario == 3) {
          this.mostrarBotonContinuar = true;
        } else {
          this.mostrarBotonContinuar = false;
        }
        this.mostrarBotonRegresar = false;
      }
      switch (this.DatosPago.tipoTarjetaCD) {
        case 0:
          this.montosPago.montoTarjetaUnaExhibicion = this.submontosPago.montoTarjetaUnaExhibicion + (this.submontosPago.montoTarjetaUnaExhibicion * 0)
          break;
        case 1:
          if(this.DatosPago.tipoPago === 0){
            this.montosPago.montoTarjetaUnaExhibicion = this.submontosPago.montoTarjetaUnaExhibicion + (this.submontosPago.montoTarjetaUnaExhibicion * 0.02)
          } else if(this.DatosPago.tipoPago === 1){
            this.montosPago.montoTarjetaUnaExhibicion = this.submontosPago.montoTarjetaUnaExhibicion + (this.submontosPago.montoTarjetaUnaExhibicion * 0.06)
          }
          break;
        case 2:
          this.montosPago.montoTarjetaUnaExhibicion = this.submontosPago.montoTarjetaUnaExhibicion + (this.submontosPago.montoTarjetaUnaExhibicion * 0.03)
          break;
      }
    },
  },
  computed: {
    comisionComputed: function(){
      let comision = 0
      switch (this.DatosPago.tipoTarjetaCD) {
        case 0:
          comision = this.submontosPago.montoTarjetaUnaExhibicion * 0
          break;
        case 1:
          if(this.DatosPago.tipoPago === 0){
            comision = this.submontosPago.montoTarjetaUnaExhibicion * 0.02
          } else if(this.DatosPago.tipoPago === 1){
            comision = this.submontosPago.montoTarjetaUnaExhibicion * 0.06
          }
          
          break;
        case 2:
          comision = this.submontosPago.montoTarjetaUnaExhibicion * 0.03
          break;
      }
      return comision
    },
  }
};
</script>

<style scoped lang="scss">
@import "../../../../../assets/estilos/estilosgenerales.scss";
.pago-principal {
  width: 100vw;
  flex-grow: 1;
}
.contenedor-metodo-pago {
  width: 75%;
}
.contenedor-botones-pago {
  display: flex;
  justify-content: flex-end;
}
.parrafo-instrucciones-pago {
  font-size: 16px;
  text-align: center;
  font-family: "Poppins";
  font-weight: 600;
  color: #1e2120;
}

.subir-otro-comprobante {
  display: flex;
  justify-content: flex-end;
}
.enviar-comprobante {
  display: flex;
  justify-content: flex-end;
}
.contenedor-metodo-pago__iframe {
  display: flex;
  justify-content: center;
}
.contenedor-metodo-pago__iframePago {
  display: flex;
  justify-content: center;
  align-items: center;
}
.iframe-pago {
  height: 580px;
  width: 100%;
  max-width: 95%;
}
.contenedor-metodo-pago__pago-previo {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.contenedor-metodo-pago__icono-pago-previo {
  color: #5ab89c;
  font-size: 52px;
}
.contenedor__no-procesado {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.contenedor__no-procesado i {
  margin-bottom: 5px;
  color: #fa0000;
  font-size: 24px;
}
.texto__no-procesado {
  text-align: left;
  font-size: 14px;
  font-weight: 600;
  color: #fa0000;
}
.contenedor-metodo-pago__titulo-pago {
  margin-top: 10px;
  font-size: 28px;
}
.pago-previo-label {
  font-size: 18px;
  font-weight: 600;
}
.boton-accion-pago {
  height: 45px;
  margin-left: 20px;
}

.resumenPago{
  color: #1e2120;
  text-align: left;
}
.resumenPago-moneda{
  color: #1e2120;
  text-align: right;
}
.titulo-seccionPago{
  text-align: left;
  font-family: "Poppins";
  font-size: 18px;
  font-weight: 600;
  color: #1e2120;
}

.botonLigaPago {
  display:flex;
  justify-content: end;
  align-items: end;
  flex-direction: column;
  padding: 0px;
}

.contenedorBoton{
  justify-content: center;
}
.contenedorBotonPago{
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.iframe-pago > .img-responsive {
  max-width: 50% !important;
}

.resumenPagoContent {
  display:flex;
  justify-content: end;
}

@media all and (max-width: 767px) {
  .contenedor__no-procesado i {
    margin-bottom: 5px;
    color: #fa0000;
    font-size: 22px;
  }
  .texto__no-procesado {
    text-align: justify;
    font-size: 12px;
    font-weight: 600;
    color: #fa0000;
  }
  .contenedor-metodo-pago {
    width: 86%;
  }
  .contenedor-metodo-pago__iframe {
    width: 99vw;
  }

  .iframe-pago {
    height: 960px;
    width: 95%;
    margin-left: 10px;
    margin-right: 5px;
  }
  .enviar-comprobante {
    margin-top: 20px;
    justify-content: center;
  }
  .enviar-comprobante button {
    width: 100%;
  }
  .contenedor-metodo-pago__icono-pago-previo {
    color: #5ab89c;
    font-size: 48px;
  }
  .contenedor-metodo-pago__titulo-pago {
    font-size: 24px;
  }
  .pago-previo-label {
    font-size: 14px;
  }
  .contenedor-botones-pago {
    flex-direction: column;
    align-items: center;
  }
  .boton-accion-pago {
    height: 45px;
    margin-left: 0px;
    margin-top: 15px;
  }
}
</style>
